import * as axios from "axios";
import { Currency } from "../../types/Currency/Currency";
import { Country } from "../../types/Country/Country";
import { RegisterRequest } from "../../types/SsoRegisterRequest";
import { PurchaseLicenceRequest } from "../../types/PendingLicencePurchase/PurchaseLicenceRequest";
import { AlertMessage, AlertType } from "../../types/AlertMessage";
import { AxiosInstance } from "axios";

export default class SsoService {
  private _currencyEndpoint = "Currency";
  private _countryEndpoint = "Countries";

  private _client: AxiosInstance;

  constructor(showAlert: (alert: AlertMessage) => void) {
    this._client = axios.default.create({
      baseURL: process.env.REACT_APP_SSO_URL,
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
        "X-ClientId": process.env.REACT_APP_CLIENT_ID,
      },
    });

    this._client.interceptors.response.use(
      (response: axios.AxiosResponse) => {
        return response;
      },
      (error: any) => {
        if (error.code === "ERR_CANCELED") {
          return;
        } else {
          showAlert({
            message: error.response?.data?.message || error.message,
            type: AlertType.Error,
          });
          return Promise.reject(error);
        }
      },
    );
  }

  public async GetCurrencies(): Promise<Currency[] | null> {
    const response = await this._client.get<Currency[]>(this._currencyEndpoint);
    return response.data;
  }

  public async GetCountries(): Promise<Country[]> {
    const response = await this._client.get<Country[]>(this._countryEndpoint);
    return response.data;
  }

  public async Register(request: RegisterRequest): Promise<void> {
    await this._client.post(
      "UserSoftware/RegisterSoftwareUser/451811CE-E537-4E5D-A385-4CBB05E90235",
      request,
    );
  }

  public async PurchaseLicence(
    request: PurchaseLicenceRequest,
  ): Promise<string> {
    const response = await this._client.post("PendingLicencePurchase", request);
    return response.data;
  }

  public async AssignTrialLicence(
    pendingLicencePurchaseId: string,
    hash: string,
    softwareLicenceId: string,
  ): Promise<any> {
    const response = await this._client.post(
      "PendingLicencePurchase/AssignTrialLicence",
      {},
      {
        params: {
          pendingLicencePurchaseId,
          hash,
          softwareLicenceId,
        },
      },
    );
    return response.data;
  }
}
